import { createReducer } from 'typesafe-actions';
import { defaultErrorHandler, defaultRequestHandler } from '../dataFetching/generators';
import { getLooksUrl } from '../../urlService';
import { LooksRawData, LooksState, Look } from './types';
import { fetchLooksActions, LooksActionsType } from './actions';

export const mapLooksData = (data: LooksRawData): Look[] => {
    return (data || []).map(look => ({
        url: getLooksUrl(look.urlKey),
        title: look.title,
        imgUrl: look.imgUrl,
    }));
};

const defaultLooksState = {
    isFetching: false,
    didInvalidate: false,
    identifier: '',
    looks: [],
};

const looksReducer = createReducer<LooksState, LooksActionsType>(defaultLooksState)
    .handleAction(fetchLooksActions.success, (state, action) => {
        return {
            ...state,
            looks: mapLooksData(action.payload.data.data),
            isFetching: false,
        };
    })
    .handleAction(fetchLooksActions.failure, (state, action) => defaultErrorHandler(state, action))
    .handleAction(fetchLooksActions.request, (state, action) => defaultRequestHandler(state, action));

export default looksReducer;
